import React from "react";
import benefitsData from "../../data/aiInEcommerceBenefits.json";

export default function Section4() {
  const bgImage = {
    backgroundImage: "url('assets/bg-image-ai-in-ecommerce.png')",
    backgroundSize: "cover", // Ensures the image covers the container
    backgroundRepeat: "no-repeat", // Prevents tiling
  };

  return (
    <div
      style={bgImage}
      className="Section4 w-full p-[2%] text-center my-[66px] md:my-0 md:mb-[5%]"
    >
      <h2 className="my-[0.67em] text-[24px] md:text-[34px] leading-[41px] font-bold text-white">
        Benefits of using AI in Ecommerce
      </h2>

      <p className="mb-5 text-white font-open">
        Mean3 offers exceptional Staff Augmentation services for critical IT to
        help you scale and optimize your project development process.
      </p>

      <div className="md:flex mt-5 mb-[25px] justify-center mx-auto w-[80%]">
        {benefitsData.map(({ title, text }, index) => {
          return (
            <div
              key={title + index}
              className="rounded-[10px] bg-white w-full md:w-[33.33%] text-left my-5 md:m-[10px_8px] p-[15px_20px]"
            >
              <h3 className="text-[16px] leading-[26px] font-bold text-black my-[0.67em]">
                {title}
              </h3>

              <p className="mb-5 text-[#2E2E2E] font-open text-[14px]">
                {text}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
